import React from 'react'
import { FormattedHTMLMessage } from '@web/walter-ui-kit'

import { GetCard } from '@web/walter-lib/api'
import { useIntl } from 'react-intl'
import styles from './style.module.css'
import { lang } from './lang'
import { globalLang } from '~globalLang'

interface Props {
    card?: GetCard
}

function EmptyHistory({ card }: Props) {
    const intl = useIntl()
    const supportLink = intl.formatMessage(globalLang.contactSupportLink)

    if (card?.status === 'SUSPENDED' || card?.status === 'BLOCKED') {
        return (
            <div className={styles.wrap} data-pointer="empty_transaction_history_placeholder">
                <FormattedHTMLMessage {...lang.title} className={styles.title} tagName="div" />
                <FormattedHTMLMessage
                    {...lang.blockedText}
                    values={{ supportLink }}
                    className={styles.text}
                    tagName="div"
                />
            </div>
        )
    }

    return (
        <div className={styles.wrap} data-pointer="empty_transaction_history_placeholder">
            <FormattedHTMLMessage {...lang.title} className={styles.title} tagName="div" />
            <FormattedHTMLMessage {...lang.text} className={styles.text} tagName="div" />
        </div>
    )
}

export default EmptyHistory
